// css
import styles from './ProductList.module.css';
// component
import Product from '../Product/Product';

// data 作品的連結和圖片（要換成自己的）
import { products } from '../../data';
const ProductList = () => {
  return (
    <div className={styles['productList']}>
      <div className={styles['productList-texts']}>
        <h1 className={styles['productList-title']}>作品集</h1>
        {/* <p className={styles['productList-desc']}>
          串接開放的電影資訊Api，並使用ReactJS製作，其中樣式是用style
          component所撰寫。
        </p> */}
      </div>
      <div className={styles['productList-list']}>
        {products.map((item) => (
          <Product
            img={item.img}
            key={item.id}
            link={item.link}
            title={item.title}
            desc={item.desc}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductList;
